import axiosNodeInstance from "../../../_config/axios.config";
import config from "../../../_config/config";
import { assessmentKitsConstants } from "../../_constants";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

//apply
// export const create_assessment_kit_action = (data) => async (dispatch) => {
//   dispatch({
//     type: assessmentKitsConstants.CREATE_ASSESSMENT_KIT_ACTION_REQUEST,
//   });
//   try {
//     const response = await axiosNodeInstance.get(
//       config.assessmentKits.assessment
//     );
//     if (response.status) {
//       dispatch({
//         type: assessmentKitsConstants.CREATE_ASSESSMENT_SKILL_KIT_ACTION_SUCCESS,
//         payload: response.data,
//       });
//       return response.data;
//     } else {
//       return false;
//     }
//   } catch (e) {
//     dispatch({
//       type: assessmentKitsConstants.CREATE_ASSESSMENT_SKILL_KIT_ACTION_FAILURE,
//       payload: e.msg,
//     });
//     showWarningMessage(e?.msg);
//     return e;
//   }
// };

// create interview
export const create_assessment_kit_action = (data) => async (dispatch) => {
  dispatch({
    type: assessmentKitsConstants.CREATE_ASSESSMENT_KIT_ACTION_REQUEST,
  });
  try {
    const response = await axiosNodeInstance.post(
      config.assessmentKits.assessment,
      data
    );
    if (response.status) {
      dispatch({
        type: assessmentKitsConstants.CREATE_ASSESSMENT_KIT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: assessmentKitsConstants.CREATE_ASSESSMENT_KIT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

// update interview
export const update_assessment_kit_action = (data, id) => async (dispatch) => {
  dispatch({
    type: assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_REQUEST,
  });
  try {
    const response = await axiosNodeInstance.put(
      `${config.assessmentKits.assessment}${id}`,
      data
    );

    if (response.status) {
      showSuccessMessage("Successfully Updated.");
      dispatch({
        type: assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_MENTOR_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

export const delete_assessment_kit_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.DELETE_ASSESSMENT_KIT_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.delete(
        `${config.assessmentKits.assessment}${id}/`
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.DELETE_ASSESSMENT_KIT_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Assessment kit is deleted successfully.");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.DELETE_ASSESSMENT_KIT_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

export const create_assessment_kit_skills_action =
  (data) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.CREATE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.post(
        config.assessmentKits.assessmentSkill,
        data
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.CREATE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.CREATE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// update interview
export const update_assessment_kit_skill_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.put(
        `${config.assessmentKits.assessmentSkill}${id}/`,
        data
      );
      if (response.status) {
        showSuccessMessage("Successfully Updated.");
        dispatch({
          type: assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.UPDATE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

export const delete_assessment_kit_skill_by_id_data_action =
  (id) => async (dispatch) => {
    let isDeleted = false;
    dispatch({
      type: assessmentKitsConstants.DELETE_ASSESSMENT_KIT_SKILLS_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.delete(
        `${config.assessmentKits.assessmentSkill}${id}/`
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.DELETE_ASSESSMENT_KIT_SKILLS_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Skill has been deleted successfully.");
        isDeleted = true;
        return isDeleted;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.DELETE_ASSESSMENT_KIT_SKILLS_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

// Get All Assessment kits
export const get_all_assessment_kits_data_action =
  (type) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.GET_ALL_ASSESSMENT_KIT_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        `${config.assessmentKits.getAssessments}${type}`
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.GET_ALL_ASSESSMENT_KIT_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.GET_ALL_ASSESSMENT_KIT_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// /get assessment kit by id
export const get_assessment_kit_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.GET_ASSESSMENT_KIT_BY_ID_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        `${config.assessmentKits.assessment}${id}/`
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.GET_ASSESSMENT_KIT_BY_ID_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.GET_ASSESSMENT_KIT_BY_ID_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

// get assigned candiates to assessment kit
export const get_assigned_candidates_to_assessment_kit_action =
  (id, status) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.GET_ASSESSMENT_KITS_CANDIDATES_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        `${config.assessmentKits.assignedCandidates}/${id}${
          status ? `?status=${status}` : ""
        }`
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.GET_ASSESSMENT_KITS_CANDIDATES_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.GET_ASSESSMENT_KITS_CANDIDATES_ACTION_SUCCESS,
        payload: e.msg,
      });
      return e;
    }
  };

// assign assessment  kit
export const assign_assessment_kit_to_candidate_action =
  (data) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.post(
        config.assessmentKits.assignAassessment,
        data
      );

      if (response.status) {
        let data = { data: [] };
        data.data.push(response.data?.data);
        dispatch({
          type: assessmentKitsConstants.ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_SUCCESS,
          payload: data,
        });
        showSuccessMessage("Assessment is assigned successfully");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.ASSIGN_ASSESSMENT_KITS_TO_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

// Get All Assessment kits
export const get_candidate_assessment_response_data_action =
  (id, candidateId) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        config.assessmentKits.assessmentAnswers
          .replace(":assessmentId", id)
          .replace(":candidateId", candidateId)
      );

      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.VIEW_CANDIDATE_ASSESSMENT_RESPONSE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const get_candidate_assigned_assessment_details_action =
  (id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        config.assessmentKits.candidateAssignedAssessmentDetails.replace(
          ":id",
          id
        )
      );

      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.GET_CANDIDATE_ASSIGNED_ASSESSMENT_DETAILS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// accept assessment kit review
export const accept_assessment_kit_review_action = (id) => async (dispatch) => {
  dispatch({
    type: assessmentKitsConstants.ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_REQUEST,
  });
  try {
    const response = await axiosNodeInstance.patch(
      config.assessmentKits.acceptKitToReview.replace(":id", id)
    );

    if (response.status) {
      dispatch({
        type: assessmentKitsConstants.ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: assessmentKitsConstants.ACCEPT_ASSESSMENT_KIT_REVIEW_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

export const shortlist_candidate_assessment_kit_action =
  (id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.patch(
        config.assessmentKits.shortlistCandidate.replace(":id", id)
      );

      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.SHORTLIST_CANDIDATE_ASSESSMENT_KIT_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const reject_candidate_assessment_kit_action =
  (id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.patch(
        config.assessmentKits.rejectCandidate.replace(":id", id)
      );

      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.REJECT_CANDIDATE_ASSESSMENT_KIT_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const assessment_kit_reviewee_remark_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.patch(
        config.assessmentKits.assessmentRevieweeRemark.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.ASSESSMENT_KIT_REVIEWEE_REMARK_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const create_candidate_response_rating_action =
  (data) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.CREATE_CANDIDATE_RESPONSE_RATING_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.post(
        config.assessmentKits.assessmentCandidateResponseRating,
        data
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.CREATE_CANDIDATE_RESPONSE_RATING_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.CREATE_CANDIDATE_RESPONSE_RATING_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const update_candidate_response_rating_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.put(
        `${config.assessmentKits.assessmentCandidateResponseRating}/${id}`,
        data
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.UPDATE_CANDIDATE_RESPONSE_RATING_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// Get All Assessment kits
export const get_skill_topics_data_action = (id) => async (dispatch) => {
  dispatch({
    type: assessmentKitsConstants.GET_SKILL_TOPICS_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosNodeInstance.get(
      config.assessmentKits.skillTopics.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: assessmentKitsConstants.GET_SKILL_TOPICS_DETAILS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: assessmentKitsConstants.GET_SKILL_TOPICS_DETAILS_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// create interview
export const create_assessment_custom_question_action =
  (data) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.post(
        config.assessmentKits.assessmentQuestion,
        data
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.CREATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

// delte custom question
export const delete_assessment_custom_question_action =
  (id) => async (dispatch) => {
    let isDeleted = false;

    dispatch({
      type: assessmentKitsConstants.DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.delete(
        `${config.assessmentKits.assessmentQuestion}${id}/`
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Skill has been deleted successfully.");
        isDeleted = true;
        return isDeleted;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.DELETE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

// Get all custom questions
export const get_assessment_custom_questions_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        `${config.assessmentKits.allAssessmentQuestions}${id}`
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.GET_ALL_ASSESSMENT_CUSTOM_QUESTIONS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// update interview
export const update_assessment_custom_question_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.put(
        `${config.assessmentKits.assessmentQuestion}${id}`,
        data
      );

      if (response.status) {
        showSuccessMessage("Successfully Updated.");
        dispatch({
          type: assessmentKitsConstants.UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.UPDATE_ASSESSMENT_CUSTOM_QUESTION_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// apply
export const get_candidates_assessments_action =
  (id) => async (dispatch) => {
    dispatch({
      type: assessmentKitsConstants.GET_CANDIDATE_ASSESSMENT_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        config.assessmentKits.candidateAssessments.replace(":hash_id", id)
      );
      if (response.status) {
        dispatch({
          type: assessmentKitsConstants.GET_CANDIDATE_ASSESSMENT_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: assessmentKitsConstants.GET_CANDIDATE_ASSESSMENT_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };
